import {  Link } from "react-router-dom"
import GlassTerrain from '../terrain/GlassTerrain'
import CardTerrain from '../terrain/CardTerrain'
import PaymentCardFormBusCom from './PaymentCardFormBusCom'
import SVWizard from './SVWizard'
import TerrainLocation from '../terrain/TerrainLocation'
import TerrainAmenitiesTabletReview from '../terrain/TerrainAmenitiesTabletReview'
import { Icon,Tag } from 'antd';
import '../../css/svr_review_react.css'
//import AddOnFormBusCom from './AddonServicesFormBusCom'
 

const React = require('react')
const _ = require('lodash')

const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

class FinalStepPaymentReviewContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(this)
        this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(this)
        


        
        this.title = 'Final Step - Review Payment'
        this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
        this.getChildContainers = this.getChildContainers.bind(me)
        this.getSojdetContainer = this.getSojdetContainer.bind(me)
        this.getBookdetContainer = this.getBookdetContainer.bind(me)
        this.getPricedetContainer = this.getPricedetContainer.bind(me)

        this.getSpaceRightContainer = this.getSpaceRightContainer.bind(me)
        this.getAddonRightContainer = this.getAddonRightContainer.bind(me)
        this.getSpecailRightContainer = this.getSpecailRightContainer.bind(me)
        this.getArrivalRightContainer = this.getArrivalRightContainer.bind(me)
        this.getCardRightContainers = this.getCardRightContainers.bind(me)
        this.svsubmitparent = this.svsubmitparent.bind(me)
        this.svguestsaveparent = this.svguestsaveparent.bind(me)
        this.svrcsubmitparent = this.svrcsubmitparent.bind(me)


        
     
      
    }
    svrcsubmitparent(bookValues){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv step2 book ajax  callback**********parent')
      console.log(bookValues)
   // const travellerOb = {my_data_traveller:bookValues }
  //  return this.props.saveTravellerReviewSuccess(travellerOb)

    }
    svguestsaveparent(bookValues){
        let me = this
       
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv step2 book ajax  callback**********parent')
      console.log(bookValues)
    const travellerOb = {my_data_traveller:bookValues }
    return this.props.saveTravellerReviewSuccess(travellerOb)

    }
    svsubmitparentWorkingSV(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
      ///essearch/spaceBookNow
      //get props.state 
      console.log(this.props.my_data_traveller)
      let comCardAndTraveller = {
        card : values,
        traveller: null
      }  
      if(this.props.my_data_traveller){
        comCardAndTraveller['traveller'] = this.props.my_data_traveller
      }
      const { cookies } = this.props;
      const svtv = cookies.get('svt')
     return this.props.priceAndTexNowSecure(comCardAndTraveller,svtv)
  
    }
  
    
    getAppDetailsMyReservation(paramQSpaceId, svcustProfile){
        console.log('caall getAppDetailsMyReservation', paramQSpaceId,svcustProfile)
        this.props.loadReviewNowMyReservationForCustId(paramQSpaceId, svcustProfile)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }

    getAppDetails(paramQSpaceId){
        this.props.loadReviewNow(paramQSpaceId)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }

    svsubmitparent(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
      ///essearch/spaceBookNow
      //get props.state 
      console.log(this.props.my_data_traveller)
      if(values ){
          values[ "rentcar"] =   values[ "rentcar"] ? "Y":'N'
          values[ "bookTaxi"] =   values[ "bookTaxi"] ? "Y":'N'
          values[ "needFlight"] =   values[ "needFlight"] ? "Y":'N'
          values[ "privateparking"] =   values[ "privateparking"] ? "Y":'N'
          values[ "otherDetails"] =   values[ "otherDetails"] ?  values[ "otherDetails"]:"UI HardCoded SVMed facility"
      }
      let comCardAndTraveller = {
        product:null,
        card : values,
        traveller: null
      }  
      if(this.props.my_data_review &&  this.props.my_data_review.booking){
          comCardAndTraveller.product = this.props.my_data_review.booking

      }
      if(this.props.my_data_traveller){
          let tvalues = this.props.my_data_traveller

          tvalues[ "state"] =   tvalues[ "state"] ?  tvalues[ "state"]:"CA"
          if(tvalues[ "bookingAgentType"]){
            tvalues[ "bookingAgentType"] =  (tvalues[ "bookingAgentType"].toLocaleLowerCase() =="selftravel" ?  "S":"O") 
          }else{
            tvalues[ "bookingAgentType"] = "S"
          }
         
          if(tvalues[ "traveType"]){
            tvalues[ "traveType"] =  (tvalues[ "traveType"].toLocaleLowerCase() =="personal" ?  "P":"B") 
          }else{
            tvalues[ "traveType"] = "P"
          }
         

          

        comCardAndTraveller['traveller'] = tvalues
      }
      let meta = {
        "addressId": -1,
        "customerId": -1,
        "cardId": -1

      }
      if(this.props.my_data_address &&  this.props.my_data_address.addressId &&  ( this.props.my_data_address.addressId >0)){
        meta.addressId = this.props.my_data_address.addressId
      }

      if(this.props.my_data_address &&  this.props.my_data_address.customerId &&  ( this.props.my_data_address.customerId >0)){
        meta.customerId = this.props.my_data_address.customerId
      }

      if(this.props.my_data_card &&  this.props.my_data_card.cardId &&  ( this.props.my_data_card.cardId >0)){
        meta.cardId = this.props.my_data_card.cardId
      }

      comCardAndTraveller.meta = meta

      const { cookies } = this.props;
      const svtv = cookies.get('svt')
     return this.props.priceAndTexNowSecure(comCardAndTraveller,svtv)
    
  
    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        console.log(this.props.svparams)
         //console.log(this.props.svparams.id)
         const {dataProfile, svcustProfile, custProfile} = this.props
         console.log('sv--dara profie from HOC+')
        console.log(dataProfile)
        console.log('sv--dara svcustProfile from HOC+')
        console.log(svcustProfile)
        console.log('sv--dara svcustProfile from svreviewreducer+')
        console.log(custProfile)
       // let custProfile = svcustProfile
         console.log('sv--dara profie from HOC end')
         

         let id;
         if(this.props.svparams){
            id = this.props.svparams.id
         
         }else{
          console.log('not called by router')
          id = 1;
          if(dataProfile && dataProfile.spaceKey){
              id = dataProfile.spaceKey;
          }
         }
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
       if(svcustProfile && svcustProfile.customerId > 0){
        this.getAppDetailsMyReservation(id,svcustProfile )
       }else{
        this.getAppDetails(id)
       }
       
       // this.props.priceAndTexNow(id);
   
			
			
	

	}

    getPricedetContainer(my_data_review){
        let price = null
        if(my_data_review && my_data_review.price){
            price = my_data_review.price
        }
        
       
        return (
            <div className="rev-row ">
                <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Yours Price Summary </text></p>
                <div className="box-outer">
                    <div className="box-left">
                        <text> Total </text>
                    </div>

                    <div className="box-right">

                        <p><text className="f19">{price.currency}{price.total?price.total :'923.46' }  </text></p>
                        <p><text className="f17sv">Include taxes and fees </text></p>


                    </div>

                </div>

                <p className="sd-content"> <text> Price Information </text></p>
                <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>IncludeSV {price.currency} {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></span></p>
                {/* 
                <p> <text className="tax-bl-total"> Incude {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></p>
                 */}
                <p>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> {price.tax.taxPercent?price.tax.taxPercent :'$6' } % MainTAX </text></span></dt>
                    <dd className="tax-ib-amt"><span className="n2">{price.currency}{price.tax.maintax?price.tax.maintax:'49.26' } </span> </dd>
                </dl>

                </p>
                <p>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line">{price.tax.citytaxPercent?price.tax.citytaxPercent :'6.5' }  % City TAX </text></span>
                    </dt>
                    <dd className="tax-ib-amt"><span className="n2"> {price.currency}{price.tax.citytax?price.tax.citytax :'53.26' }  </span> </dd>
                </dl>
                </p>
                {/*  
                <p>
                <dl>

                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Damage Deposit (Fully
                                refundable) </text></span></dt>
                    <dd className="tax-ib-amt"><span className="n2"> {price.total?price.total :'$200.26 ' }</span> </dd>
                </dl>
                </p>
                */}
                <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(43, 127, 236)' }} type="diff" theme="filled" /><text style={{paddingLeft: "10px"}}>Damage Deposit(Fully Refun) {price.currency}{price.total?price.total :'200.26 ' }</text></span></p>

                </div>  
            </div>
)
    }
    getBookdetContainer(my_data_review){
        
        let Request = null
        if(my_data_review && my_data_review.Request){
            Request = my_data_review.Request
        }
        const stayWithUnits = (Request.stay? Request.stay: '6')  + ' ' + (Request.stayInit? Request.stayInit: 'nights') 
        return(
            <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Yoursv Booking Details </text></p>
                <div className="box-outer">
                    <div className="rev-sd-left">
                        <p className="sd-check"><text>Check-in </text></p>
                        <p className="sd-content"><text>{Request.checkinTime?Request.checkinTime :'Tue, Dec 10, 2024 ' } </text></p>
                        <p className="sd-check"><text>{Request.checkinTimePrefix?Request.checkinTimePrefix :'From 3:00 PM' } </text></p>
                    </div>

                    <div className="rev-sd-right">

                        <p className="sd-check"><text>Check-out </text></p>
                        <p className="sd-content"><text>{Request.checkoutTime?Request.checkoutTime :'Fri, Dec 13, 2024' }  </text></p>
                        <p className="sd-check"><text>{Request.checkoutTimePrefix?Request.checkoutTimePrefix :'Until 11:00 AM' }  </text></p>

                    </div>

                </div>

                <p> <text> Total length of stay </text></p>
                <p> <text> {stayWithUnits? stayWithUnits:'6 nights' } </text></p>
            </div>
            </div>)
    }
    getSojdetContainer(my_data_review){
        let booking = null, svr_location, soj, rating_info, rating_text, rating_num
        let amenity_name = []

        if(my_data_review && my_data_review.booking){
            booking = my_data_review.booking
            soj = booking
             svr_location = {
                "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                "county": soj['county'] ? soj['county'] : "albanyt",
                "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                "country": soj['country_name'] ? soj['country_name'] : "usa",
               "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
               "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                
               "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
               "state":soj['state'] ? soj['state'] : "NY"

            }
            rating_text = soj['sv_rating'] ? soj['sv_rating']: 'Excelellent'
            rating_num = soj['avg_stars_rating'] ? soj['avg_stars_rating']: 5
            rating_info = rating_text + ' Location -- ' + rating_num
        }
        if(booking && booking.en_activity_name_lvl && booking.en_activity_name_lvl.length > 0){

            amenity_name = booking.en_activity_name_lvl
        }else if(my_data_review && my_data_review.amenity_name && my_data_review.amenity_name.length > 0){
            amenity_name = my_data_review.amenity_name
        }

        return(  <div className="rev-row ">
            
            <div className="card card--raised with-shadow">
            
                
           
        <p className="sd-check"><text>Hotel </text></p>
        <p className="sd-content"> <text>{svr_location.resort_name? svr_location.resort_name:'Hotel Monreale Express International Drive Orlando' }   </text></p>
        <p className="sd-check"> <text> {svr_location.address_line1}, {svr_location.county}, {svr_location.postalcode} , {svr_location.country} 
                       </text>
        </p>
        <p className="sd-rating"> <text style={{fontSize:'12px', fontWeight:'300'}}>{rating_info? rating_info:'Excellent, 9.1' }   </text></p>
        
        <p className="sd-numreview">  <span style={{fontSize: "14px"}} ><Tag color="magenta">5.0</Tag> <text ><span style={{paddingLeft: "10px"}}>{booking? booking.num_reviews_label: 'Good , '}</span> <span> {svr_location.num_reviews} Reviews </span></text></span></p>
        
        
         
        <div className="box-left-listhotels">
                                           
                                            <p className="m-para-text">
                                           
                                                {this.getHotelAmenityList(booking.en_activity_name_lvl)}
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Wifi</text></span>
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Bath tub</text></span>
                                                
                                                
                                            </p>
        </div>
       

        </div>
        
    </div>
)
    }
    getSpaceRightContainer(my_data_review){
       // const {spaceDet} = my_data_review
       let spaceDet = {
        
        "space_details": "Queen Room with Two Queen Beds",
        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
        "cancellation": "Free cancellation before December 9, 2024 ",
        "guests": "2 adults ",
        "cleaniness_score" : "7.7",
        "non_smoking":true,

        "space_amenity_name": [
            "300 feet elevator",
            "air conditioning",
            "private bathroom"
        ]
       
       
    }
        let booking = null
        let amenity_name = null
        let soj = spaceDet 
        let amenities =[
            "Swimming Beach",
            "Tennis, Water"
        ]
        
        if(my_data_review && my_data_review.spaceDet){
            spaceDet = my_data_review.spaceDet
        }
        if(my_data_review && my_data_review.booking){
            booking = my_data_review.booking
        }
        if(booking && booking.en_activity_name_lvl && booking.en_activity_name_lvl.length > 0){

            amenities = booking.en_activity_name_lvl
        }else if(my_data_review && my_data_review.amenity_name && amenity_name.length > 0){
            amenities = my_data_review.amenity_name
        }

        //let amenities =  soj['amenity_name']?  soj['amenity_name'] : []
        return(
            <div className="rev-row">
            <div className="card card--raised with-shadow">

<p className="right-sd-content"> <text>{spaceDet.space_details? spaceDet.space_details:'Queen Room with Two Queen Beds' }  </text></p>
<p className="sd-check"> <text> {spaceDet.propertyAddress? spaceDet.propertyAddress:'6825 Visitor Circle, Orlando, FL 32891, USA' } </text>
</p>
<p className="right-sd-rating"> <text>{spaceDet.cancellation? spaceDet.cancellation:'Free cancellation before December 9, 2024' }    </text></p>
<p className="sd-numreview"> <text> <span> Guests: </span> <span>  {spaceDet.guests? spaceDet.guests:'2 adults ,'}</span> </text></p>

<p className="sd-check"> <text> Cleanliness score – {spaceDet.cleaniness_score? spaceDet.cleaniness_score:'7.7' }   </text></p>
<p className="sd-check"> <text> {spaceDet.non_smoking? 'Non Smoking':'Smoking' }   </text></p>
<TerrainAmenitiesTabletReview  amenities={amenities}></TerrainAmenitiesTabletReview>

<div className="box-outer">
        {spaceDet.space_amenity_name.map((ahobby,idx)=>{ return (
                 <div className="hd-ib-amenity">
                 <p className="sd-check"><text>{ahobby} </text></p>
             </div>

            )})
            
            }


</div>


</div>
</div>

        )

    }
    getAddonRightContainer(){
         const {handleSubmit,svsubmitparent, pristine,  submitting }  = this
        return ( <div className="rev-row">
             <div className="card card--raised with-shadow">
        <p className="right-sd-content"> <text> Add to your stay </text></p>


        <div className="box-outer">
           {/* 
        <AddOnFormBusCom onSubmit={svsubmitparent}></AddOnFormBusCom>
             */}       
            <div className="add-ib-ck">
                <p className="sd-check"><text>ck </text></p>
            </div>

            <div className="add-ib-content">


                <p className="sd-check"><text>I will need a flight for my trip </text></p>
                <p className="sd-desc"><text>Flexible flight options from San Francisco to Orlando starting at
                        ‎$473‏ round-trip. Finish booking this stay to get flight recommendations that match
                        your selected dates. </text></p>


            </div>
            <div className="add-ib-icon">

                <p className="sd-check"><text>car </text></p>


            </div>

        </div>

        <div className="box-outer">
            <div className="add-ib-ck">
                <p className="sd-check"><text>
                    ck
                     </text></p>
            </div>

            <div className="add-ib-content">
                <p className="sd-check"><text>I m interested in renting a car </text></p>
                <p className="sd-desc"><text>Make the most of your trip – check out car rental options in your
                        booking confirmation.</text></p>
            </div>
            <div className="add-ib-icon">
                <p className="sd-check"><text>car </text></p>
            </div>

        </div>

        <div className="box-outer">
            <div className="add-ib-ck">
                <p className="sd-check"><text>ck </text></p>
            </div>

            <div className="add-ib-content">


                <p className="sd-check"><text>Want to book a taxi or shuttle ride in advance? </text></p>
                <p className="sd-desc"><text>Avoid surprises – get from the airport to your accommodations without
                        any hassle. We'll add taxi options to your booking confirmation.</text></p>


            </div>
            <div className="add-ib-icon">

                <p className="sd-check"><text>car </text></p>


            </div>

        </div>


        </div>

    </div>)
        
    }
    getSpecailRightContainer(){
        return ( <div className="rev-row">
             <div className="card card--raised with-shadow">
        <p className="right-sd-content"> <text> Special requests </text></p>
        <p className="sd-check"> <text>Special requests can't be guaranteed, but the property will do its best to
                meet your needs. You can always make a special request after your booking is complete.</text>
        </p>


        <div className="box-outer">
            <div className="add-ib-ck">
                <p className="sd-check"><text>ck </text></p>
            </div>

            <div className="add-ib-content">


                <p className="sd-check"><text>I would d like free private parking on site </text></p>


            </div>


        </div>



        </div>

    </div>
)
        
    }
    getArrivalRightContainer(){
        return (<div className="rev-row">
             <div className="card card--raised with-shadow">

        <p className="right-sd-content"> <text> Your arrival time </text></p>

        <p className="sd-check"> <text> our room will be ready for check-in at 3:00 PM </text></p>
        <p className="sd-check"> <text> 24-hour front desk – help whenever you need it! </text></p>

        <p className="sd-check"> <text style={{fontWeight:'300', color:'green', fontSize:'12px'}} > Time is for Orlando time zone </text></p>

</div>

    </div>
)
        
    }

    getCardRightContainers() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]

       const {handleSubmit,svsubmitparent,svguestsaveparent, svrcsubmitparent,pristine,  submitting }  = this
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        const {my_data_price_confirmation, custProfile, my_data_address, my_data_card,errob, crudsuccessob, errorRESERVATION } = this.props
        console.log('a29 IMP***')
        console.log(crudsuccessob)
        console.log(errorRESERVATION)
        console.log('a29e***')
        return (
            <div>
                <SVWizard errorRESERVATION={errorRESERVATION} errob={errob} crudsuccessob={crudsuccessob} my_data_card={my_data_card} my_data_address={my_data_address} custProfile={custProfile} sv_price_confirmation={my_data_price_confirmation} svrcsubmitparent={svrcsubmitparent}  svrcsubmitparent={svrcsubmitparent} svguestsaveparent={svguestsaveparent} svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></SVWizard>
                {/* 
                <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                     */}
                </div>   
                )
    }

    getHotelAmenityList(ar){
        
        
        ar = ar || []
       return ar.map( (v, idx)=>{
           if(v.toLocaleLowerCase() == "swimming beach"){
            return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }else if(v.toLocaleLowerCase() == "tennis"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else if(v.toLocaleLowerCase() == "water"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else{

            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }
          })
       


    }
    getChildContainers(){
        /*   <TerrainLocation  svrlocation={svr_location}></TerrainLocation> */
        const lastestUpdateDate = 'Data Refresh Daily'
        let custProfile = null
        let soj = null, data = [], hosts = [], dbs = [], sojourns = [],my_data_review = {} ,my_data = []
        let svrreview = {
           
            "num_reviews": 12364,
            "num_reviews_text": "reviews",
            "sv_rating": "Excellent",
            "sv_rating_no": 5
        }
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        let svr_tablets = []
        //let svr_tablets = ["http://localhost:8080/images/soj2.jpg", "http://localhost:8080/images/soj3.jpg", "http://localhost:8080/images/soj4.jpg", "http://localhost:8080/images/soj5.jpg", "http://localhost:8080/images/soj6.jpg" ]
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
           // soj = my_data[0]
        }
        if (this.props.my_data_review ) {
            my_data_review = this.props.my_data_review
            soj = my_data_review.booking
          
        }
        if (this.props.custProfile ) {
            custProfile = this.props.custProfile
           
          
        }
        if (this.props.svr_soj_detail_images_ob && (this.props.svr_soj_detail_images_ob.gallery.length > 0)) {
            svr_tablets = this.props.svr_soj_detail_images_ob.gallery
           
        }
        soj = soj ? soj : {}
       
        let amenities =  soj['en_activity_name_lvl']?  soj['en_activity_name_lvl'] : []
        let highlights =  soj['highlights']?  soj['highlights'] : 'ante, venenatis non adipiscing vitae'
        let svr_location = {
            "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
            "country": soj['country_name'] ? soj['country_name'] : "usa",
           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
            
           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
           "state":soj['state'] ? soj['state'] : "NY"

        }
        let svr_location_old = {
            "resort_name": soj['resort_name'] ? soj['resort_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postalcode'] ? soj['postalcode'] : 12193,
            "market_code":soj['market_code'] ? soj['market_code'] :  "NAMER",
            "country": soj['country'] ? soj['country'] : "usa",
           
            "state":soj['state'] ? soj['state'] : "NY",
        }
        let reservekey = 'insvreview'
        return (
            <div className="svr-det-pageWrapper">
    <header className="svr-header1">
        <h1> Sojourn View Detail</h1>
    </header>
    
    <TerrainLocation reservekey={reservekey}  svrlocation={svr_location}></TerrainLocation>
       



    <div className="svr-gal-contentWrapper">
        <aside className="siberbar-left">
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getSojdetContainer(my_data_review)}></CardTerrain>
                    
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getBookdetContainer(my_data_review)}></CardTerrain>
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getPricedetContainer(my_data_review)}></CardTerrain>
            
        </aside>
        <article className="main-right">
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getSpaceRightContainer(my_data_review)}></CardTerrain>
           
            {/* 
             <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getAddonRightContainer()}></CardTerrain>
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getSpecailRightContainer()}></CardTerrain>
       
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getArrivalRightContainer()}></CardTerrain>
            */}
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getCardRightContainers()}></CardTerrain>
   
            
            

        </article>
    </div>




    <br />


            {/*  

    <footer>
        <p>Copyright 2013, SV Greek Text Generator, Inc.</p>
        <p>Contact <a href="mailto:nobody@nowhere.com"> w-mail@xx.com</a> </p>
    </footer>
 */}

</div>
        
        )

    }

    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title} = this
        const {dataProfile, custProfile} = this.props

       
        const { cookies } = this.props;
        let svcookoffer_o =cookies.get('svcook')
        if(!svcookoffer_o){
            cookies.set('svcook', 'jskSfo', { path: '/' })
        }
        console.log('********OCT25**************** COOKIES svcookoffer we might be creat END', svcookoffer_o)
        

       /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */
    

          return (

            
            <div className="col-md-12">
                
                 
                <GlassTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainers()}></GlassTerrain>
                
            </div>
        )
        
    }
}
export default FinalStepPaymentReviewContainer